/* BILLING */
export const GET_BILLING = "GET_BILLING"
export const GET_BILLING_SUCCESS = "GET_BILLING_SUCCESS"
export const GET_BILLING_FAIL = "GET_BILLING_FAIL"
